<template>
  <div class="user_card_container">
    <div class="my_row user_card_name">
      <div style="float: left">{{ nickname }}</div>
      <div style="float: left" class="link" @click="linkWebsite()" v-if="company_website !== ''">
        <van-icon name="link-o" /> 链接
      </div>
      <img :src="require('@/assets/icon/icon_close.png')" width="24" height="24" style="float: right;" @click="iconClose"/>
<!--      <span class="btn" v-if="false">{{networkStatus}}</span>
      <span class="btn" v-if="false">{{$store.state.networkStr}}</span>-->
    </div>
    <div class="my_row card_bottom user_card_extra">

      <div class="top_bar_title_bottom_company" v-if="title === '' && company_name === ''">暂无公司和职位</div>
      <div v-else>
        <div class="top_bar_title_bottom_job"> {{ title }}</div>
        <div class="top_bar_title_bottom_company">{{ company_name }}</div>
      </div>
    </div>

    <!-- 爱好 -->
    <div
      v-if="hobbies.length"
      class="container-item hx-flex-c-c hx-flex-j-s my_row card_bottom"
    >
      <div class="ah-title">
        <span
          :style="{
            display: 'inline-block',
            width: '10px',
            height: '10px',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${require('/src/assets/icon/ah.png')})`,
          }"
        ></span>
        爱好：
      </div>
      <div class="hx-text-ellipsis" style="flex: 1; font-size: 0">
        <span class="ah-tag" v-for="(item, index) in hobbies" :key="index">{{
            item
          }}</span>
      </div>
    </div>

    <!-- 标签 -->
    <div v-if="tags.length" class="container-item hx-flex-c-c hx-flex-j-s my_row card_bottom">
      <div class="ah-title bq-title">
        <span
          :style="{
            display: 'inline-block',
            width: '10px',
            height: '10px',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${require('/src/assets/icon/bq.png')})`,
          }"
        ></span>
        标签：
      </div>
      <div class="hx-text-ellipsis" style="flex: 1; font-size: 0">
        <span
          class="ah-tag bq-tag"
          :style="{
            background: selectColor(index),
          }"
          v-for="(item, index) in tags"
          :key="index"
        >{{ item }}</span>
      </div>
    </div>

    <!--    群聊 留言 电话-->
    <div class="fun_div my_row" v-if="false">
      <div class="fun_group_chat fun_item" @click="groupChatClick" v-if="haveToken && qrCodeGroup !== ''">
        <div class="fun_item_icon">
          <img :src="icon_group_chat" :width="23" :height="23"/>
        </div>
        <div class="fun_item_text">
          群聊
        </div>
      </div>

      <div class="fun_message fun_item"  @click="liuYanClick" v-if="haveToken && ($store.state?.vuex_app_user_info?.deny_feedback)">
        <div class="fun_item_icon">
          <img :src="icon_message" :width="23" :height="23"/>
        </div>
        <div class="fun_item_text">
          留言
        </div>
      </div>

      <div class="fun_phone fun_item" @click="phoneClick" v-if="haveToken && ($store.state?.vuex_app_user_info?.hide_phone)">
        <div class="fun_item_icon">
          <img :src="icon_phone" :width="23" :height="23"/>
        </div>
        <div class="fun_item_text">
          电话
        </div>
      </div>

<!--      <div class="care_div custom_care" v-if="$store.state.weiXinMark" :class="{ 'color_gray': isCare }" @click="toggleCare(isCare)">
        <img :src="require('@/assets/icon/icon_add.png')" width="17px" height="17px" v-if="!isCare"> {{careText}}
        &lt;!&ndash;<img v-if="!showLove" :src="require('@/assets/icon/icon_love_2.png')" width="24" height="24" class="icon_love" @click="toggleLove(showLove)">
            <img v-else :src="require('@/assets/icon/icon_love_3.png')" width="24" height="24" class="icon_love" @click="toggleLove(showLove)">&ndash;&gt;
      </div>-->
    </div>

<!--    <van-action-sheet
      v-model="phoneShow"
      :actions="actions"
      cancel-text="取消"
      :description="phone"
      close-on-click-action
      @select="onSelect"
    />-->


  </div>
</template>

<script>
import { feedback, follow, unfollow } from '@/api/app'
import { url_to_query } from '@/plugins/getUrlParam'

export default {
  name: "UserCardContainer",

  data() {
    return {
      bqBgMap: {
        0: "rgba(30,223,65, 0.3)",
        1: "rgba(224,32,32, 0.3)",
        2: "rgba(0,145,255, 0.3)",
      },
      content: '',
      msgLoading: false,
      icon_group_chat: require('@/assets/icon/icon_group_chat.png'),
      icon_message: require('@/assets/icon/icon_message.png'),
      icon_phone: require('@/assets/icon/icon_phone.png'),
      isCare: false,
      phoneShow: false,
      actions: [{ name: "呼叫" }],
      networkStatus: '无网络状态',


    };
  },
  computed: {
    haveToken() {
      return this.$store.state?.vuex_app_token !== ''
    },
    nickname() {
      return this.vuex_app_user_info?.nickname || "-";this.$store.state?.vuex_cardInfo?.title
    },
    biography() {
      return this.vuex_app_user_info?.biography || "-";
    },
    title() {
      return this.vuex_app_user_info?.title || ''
    },
    company_name() {
      return this.vuex_app_user_info?.company_name || ''
    },
    hobbies() {
      return this.vuex_app_user_info?.hobbies || [];
    },
    tags() {
      return this.vuex_app_user_info?.tags ||  []
    },
    qrCodeGroup() {
      return this.$store.state?.vuex_app_user_info?.wechat_qr_code || "";
    },
    phone() {
      // return this.$store.state?.vuex_app_user_info?.phone || "";
      if (this.$store.state?.vuex_app_user_info?.mobile_num){
        return this.$store.state?.vuex_app_user_info?.mobile_num
      } else {
        return this.$store.state?.vuex_app_user_info?.phone || '';
      }
    },
    company_website(){
      return this.vuex_app_user_info?.company_website || ''
    },
    careText(){
      return this.isCare ? '已关注' : '关注'
    },
  },
  mounted() {

    // 检测网络连接状态
    if (navigator.onLine) {
      console.log('网络连接正常');
      // 执行其他操作，比如加载数据等
      this.networkStatus = '网络连接正常'
    } else {
      console.log('网络连接异常');
      this.networkStatus = '网络连接异常'
      // 可以在这里处理无网络连接的情况
    }
    // 监听网络状态变化
    window.addEventListener('online', this.handleOnlineStatus);
    window.addEventListener('offline', this.handleOfflineStatus);
  },
  beforeDestroy() {},
  methods: {
    linkWebsite() {
      if (!this.vuex_app_user_info?.company_website) {
        this.$myToast({
          type: "fail",
          message: "无链接地址",
        });
        return;
      }
      // location.href = this.vuex_app_user_info?.company_website;
      this.$myDialog({
        title: "网页跳转提示",
        message: this.vuex_app_user_info?.company_website,
        showCancelButton: true,
        confirmButtonText: "确认跳转",
        closeOnClickOverlay: true,
      })
        .then((result) => {
          location.href = this.vuex_app_user_info?.company_website;
        })
        .catch((err) => {});
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      if (item.name == "呼叫") {
        this.aLink(`tel:${this.phone}`);
      }
    },
    selectColor(index) {
      const i = index;
      const a = i % Object.keys(this.bqBgMap).length;
      // console.log("selectColor@@", a);

      return this.bqBgMap[a] || "";
    },



    handleOnlineStatus() {
      console.log('网络已连接');
      // 执行网络已连接后的操作
      this.networkStatus = '网络已连接'
    },
    handleOfflineStatus() {
      console.log('网络已断开');
      // 执行网络已断开后的操作
      this.networkStatus = '网络未连接'
    },
    liuYanClick() {
      this.$emit('liuyanShow', true)
    },
    groupChatClick() {
      this.$emit('qunLiaoShow', true)
    },
    phoneClick() {
      if (!this.phone) {
        this.$myToast({
          type: "fail",
          message: "暂无手机号",
        });
        return;
      }
      this.phoneShow = true;
    },
    aLink(href = "") {
      // 创建隐藏<a>标签进行下载
      const tempLink = document.createElement("a");
      tempLink.style.display = "none";
      tempLink.href = href;
      // tempLink.setAttribute("download", this.fileDialogData?.name);
      // if (typeof tempLink.download === "undefined") {
      //   tempLink.setAttribute("target", "_blank");
      // }
      document.body.appendChild(tempLink);
      tempLink.click();
      this.$nextTick(() => {
        document.body.removeChild(tempLink);
      });
    },
    iconClose(){
      this.$emit('closeUserCard')
    }
  },
};
</script>

<style lang="less" scoped>
  .my_row {
    float: left;
    width: 100%;
  }

  .user_card_container{
    /*z-index: 999;
    width: 50%; // 不给小一点会撑开。。。可能有优先级吧
    flex: 1;
    background: #252525;
    padding: 12px 16px 16px 16px;
    box-shadow: 0px 2px 11px 4px rgba(0,0,0,0.3);
    border-radius: 12px;
    font-family: PingFangSC, PingFang SC;*/
    .user_card_name{
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 25px;
      text-align: left;
      font-style: normal;
      margin-bottom: 11px;
      .link {
        color: #1edf41;
        font-size: 12px;
        border-radius: 8px;
        padding: 2px;
        margin-left: 5px;
      }
      .link:active {
        background: rgba(0, 0, 0, 0.3);
      }
    }
    .user_card_extra{
      font-weight: 400;
      font-size: 10px;
      color: #FFFFFF;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      margin-bottom: 17px;

      .top_bar_title_bottom_job{
        float: left;
        max-width: 100px;
        margin-right: 6px;

        padding: 2px 7px;
        background: #383838;
        border-radius: 4px;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .top_bar_title_bottom_company{
          float: left;
          max-width: 150px;

          padding: 2px 7px;
          background: #383838;
          border-radius: 4px;

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
    }
  }

  .fun_div{
    display: flex;
    width: 100%;
    height: 44px;
    margin-top: 12px;

    .fun_item{
      width: 27px;
      height: 44px;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 17px;
      text-align: left;
      font-style: normal;
      .fun_item_icon{
        float: left;
        width: 23px;
        height: 23px;
        margin-bottom: 4px;
      }
      .fun_item_text{
        float: left;
        width: 100%;
        height: 16px;
      }
    }
    .fun_group_chat{
      margin-right: 32px;
    }
    .fun_message{
      margin-right: 32px;
    }
    .fun_phone{
      margin-right: 32px;
    }
    .care_div{
      float: left;
      display: flex;
      flex: 1;
      height: 44px;
      border-radius: 22px;
      align-items: center;
      justify-content: center;
      background: #1edf41;
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 25px;
      letter-spacing: 2px;
      text-align: left;
      font-style: normal;
      cursor: pointer;
      transition: background-color 0.3s; /* 添加过渡效果 */
      box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
    }
    .clickable-div:active {
      background: linear-gradient(to bottom, #07c160, #adadad); /* 点击时背景色渐变 */
    }

  }

  .color_gray{
    background: #adadad !important;
  }

  .ah-title {
    font-size: 12px;
    color: #32c5ff;
    line-height: 1;
    padding: 3px 0;
    // margin-right: 2px;
  }
  .bq-title {
    color: #1edf41;
  }
  .ah-tag {
    display: inline-block;
    font-size: 12px;
    color: #fff;
    line-height: 1;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
    padding: 2px 4px;
    margin: 0 2px;
  }
  .card_bottom{
    margin-bottom: 12px;
  }
</style>
